module.exports = __webpack_public_path__ + "img/catalogs.1e9fad3b.png";